import { Injectable } from '@angular/core';
import { FieldDataType, Filter, FilterGroup, FilterGroupType, QueryParams, QueryResult, RuleOperator } from '../store/models';

@Injectable({ providedIn: 'root' })
export class GridHelperService {
  searchClause: string;
  searchTerm: string;
  searchFilterGroup: FilterGroup;

  constructor() {}

  gridParamsToRequestParams(params, filterClause?: string): QueryParams {
    const sortAndDirection = generateSort(params.sortModel);

    const where = this.generateWhere(params, filterClause);

    var queryParams: QueryParams = {
      skip: params.startRow,
      take: params.endRow - params.startRow,
      sortField: sortAndDirection?.field,
      sortDirection: sortAndDirection?.direction,
      sort: sortAndDirection ? `${sortAndDirection?.field} ${sortAndDirection?.direction}` : null,
      include: null,
      where: where
    };

    // Remove empty parameters
    Object.keys(queryParams).forEach(k => !queryParams[k] && queryParams[k] !== 0 && delete queryParams[k]);
    return queryParams;
  }

  queryResultToGridData(response) {
    var myReturnedData = {
      rowData: response?.data,
      rowCount: response?.totalCount
    };

    return myReturnedData;
  }

  generateSearchClause(searchTerm: string, columns: any[]): FilterGroup {
    var clausePieces = [];
    var filters = [] as Filter[];
    this.searchTerm = searchTerm;

    if (!searchTerm) {
      this.searchClause = null;
      this.searchFilterGroup = null;
      return;
    }

    columns.forEach(c => {
      if (
        !c.colId.startsWith('_') && c.colId !== "external_id" &&
        (c.cellRendererParams?.schemaField?.dataType === FieldDataType.Text ||
          c.cellRendererParams?.schemaField?.dataType === FieldDataType.AutoIncrement ||
          !!c.cellRendererParams?.sortFieldName)
      ) {
        const filterColumnId = !!c.cellRendererParams?.sortFieldName ? c.cellRendererParams?.sortFieldName : c.colId;
        clausePieces.push(
          `${filterColumnId}.ToLower().Contains("${searchTerm.replace('"', '\\"').toLocaleLowerCase()}")`
        );
        filters.push({
          field: filterColumnId,
          operator: RuleOperator.ContainsNoCase,
          value: searchTerm
        });
      }
    });

    this.searchClause = `${clausePieces.join(' OR ')}`;

    this.searchFilterGroup =
      filters.length > 0
        ? {
            groupType: FilterGroupType.Or,
            filters: filters,
            filterGroups: []
          }
        : null;

    return this.searchFilterGroup;
  }

  getSearchFilter() {
    return this.searchFilterGroup;
  }

  clearSearchFilter() {
    this.searchFilterGroup = null;
    this.searchClause = null;
  }

  generateWhere(params: GridParams, filterClause?: string) {
    //todo for each set filter turn filter obj into a where statement
    var whereClause: string;

    if (!!this.searchClause) {
      if (!!filterClause) {
        whereClause = `(${filterClause}) AND (${this.searchClause})`;
      } else {
        whereClause = this.searchClause;
      }
    } else {
      if (!!filterClause) {
        whereClause = filterClause;
      }
    }
    return whereClause;
  }
}

function generateSort(sortModel: AgSortModel[]) {
  var sortObj: { direction: string; field: string };

  if (sortModel.length > 0) {
    var direction = sortModel[0].sort === 'asc' ? 'Ascending' : 'Descending';
    sortObj = {
      direction,
      field: sortModel[0].colId
    };
  }

  return sortObj;
}

export interface GridParams {
  startRow: number;
  endRow: number;
  rowGroupCols: any[];
  valueCols: any[];
  pivotCols: any[];
  pivotMode: boolean;
  groupKeys: any[];
  filterModel: any;
  sortModel: any[];
}

export interface RowResponse {
  lastRow: number;
  rows?: any;
}

export interface AgSortModel {
  colId: string;
  sort: 'asc' | 'desc';
}
